import React from 'react';
import { metricKeys } from '@pulse/metrics';
import { Skeleton } from 'antd';
import { useAtom, useSetAtom } from 'jotai';
import { granularityAtom, intervalAtom } from '@src/components/usage-dashboard/atoms';
import { useGetDataForMetric } from '@src/components/usage-dashboard/hooks/useMetricSeries';
import getGranularity from '@utils/granularity';
import UsageDatePicker from './DatePicker/UsageDatePicker';
//import TotalViewersHoursWidget from './Widgets/TotalViewersHours';

const UsageSummary = () => {
  const [interval, setInterval] = useAtom(intervalAtom);
  const setGranularity = useSetAtom(granularityAtom);

  const onRangeChange = (dates) => {
    if (dates) {
      const from: any = dates[0].startOf('day');
      const to: any = dates[1].endOf('day');
      const g = getGranularity(from, to, true);
      setInterval([from, to]);
      setGranularity(g);
    }
  };

  const metricSeriesData: any = useGetDataForMetric(metricKeys.IntervalMinutesPlayedWithAds);

  return (
    <div style={{ display: 'flex', marginTop: 10 }}>
      {metricSeriesData.isFetching ? (
        <Skeleton paragraph={{ rows: 0 }} active style={{ marginTop: 17, marginLeft: 10 }} />
      ) : (
        <div style={{ display: 'flex' }}>
          {/* <TotalViewersHoursWidget></TotalViewersHoursWidget> */}
        </div>
      )}
      <div style={{ marginLeft: 'auto', marginRight: 0 }}>
        <UsageDatePicker onRangeChange={onRangeChange} defaultValue={interval}></UsageDatePicker>
        <div style={{ margin: 0, fontSize: 'x-small', textAlign: 'right', paddingRight: 25 }}>
          Timezone In UTC
        </div>
      </div>
    </div>
  );
};

export default UsageSummary;
